import React, {Component} from "react";
import {Card} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css";
import "../Elements/AscElements/PhoneBookElements.css";
import AscModal from "../Elements/Modal/Modal";
import {ViewPhoneBookExistingExternalNum, ViewPhoneBookNewExternalNum} from "../Elements/AscElements/PhoneBookElements";


export default class PhoneBookUnifyModal extends Component {
    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}>
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.PhoneBookInfo}
                        </Card.Title>
                    </Card.Header>

                    <Card.Body className="phonebook-unify-card-body">
                        <div className="phonebook-unify-section">
                            <ViewPhoneBookExistingExternalNum
                                state={this.props.state}
                                langText={this.props.langText}
                                sprintf={this.props.sprintf}
                            />
                        </div>
                        
                        <div className="phonebook-unify-section">
                            <ViewPhoneBookNewExternalNum
                                state={this.props.state}
                                langText={this.props.langText}
                                sprintf={this.props.sprintf}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
} 